module.exports = __webpack_public_path__ + "img/tsr-background.98cac40f.jpeg";